<!--登录框-->
<template>
  <div class="Login">
    <!--学员已登录-->
    <!--<div class="new_login_box" v-if="userInfo!=null">
      <div class="new_user_box_info">
        <div class="new_user_box_info_head"><img :src="userInfo.imageUrl"></div>
        <div class="new_user_box_info_text">
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td align="left" valign="middle"><span>{{userInfo.realName}}</span><br>恭喜您登录成功！</td>
            </tr>
            <input type="hidden" id="name" v-model="userInfo.realName"/>
          </table>
        </div>
      </div>
      <div class="new_user_box_a">
        <router-link title="进入学习中心" to="/usercenter" class="gotostudycenter">进入学习中心</router-link>
        <a href="#" class="bindstudycard" @click="showLearnCardBind=true">绑定学习卡</a>
        <learnCardBind :value.sync="showLearnCardBind"></learnCardBind>
      </div>
    </div>-->
    
    
    <div class="symt_login">
      <div class="symt_login_title"><span>用户登录</span><!--<a href="#">注册及使用流程</a>--></div>
      <div class="symt_login_box">
        <div v-if="accountCellSwitch === 1" class="account_login">
          <el-input v-model="usernameS" autocomplete="new-password" placeholder="请输入用户名"
            prefix-icon="el-icon-user" size="small"
            style="width: 100%"
            type="text"/>
          <el-input v-model="passwordS" autocomplete="new-password" placeholder="请输入密码" prefix-icon="el-icon-lock"
            size="small"
            type="password" />
          <div class="nlb_useragreenment" style="font-size:11px;">
            <el-checkbox style="padding-right: 5px;" v-model="protocol"></el-checkbox>已阅读并同意
            <a href="https://source.yiboshi.com/licence/0417_shiyan/user.html" class="link">《用户协议》</a>和
            <a href="https://source.yiboshi.com/licence/0417_shiyan/pryvacy.html" class="link">《保护政策》</a>
          </div>
          <el-button :disabled="subBtnDisabled()" size="mini" style="width: 100%" type="primary"
            @click="loginS('login')">
            登录
          </el-button>
        </div>
        <div v-if="accountCellSwitch === 2" class="sms_login">
          <el-input v-model="usernameCell" autocomplete="new-password" placeholder="请输入手机号"
            prefix-icon="el-icon-mobile-phone" size="small"
            style="width: 100%"
            type="text"/>
          <div class="code">
            <el-input v-model="passwordYzm" autocomplete="new-password" placeholder="请输入验证码"
              prefix-icon="el-icon-message" size="small"
              type="password"/>
            <el-button :disabled="yzmbtn()" size="mini" type="primary" @click="getyzm()">{{ sendSmsButtonText() }}
            </el-button>
          </div>
          <div class="nlb_useragreenment" style="font-size:11px;">
              <el-checkbox style="padding-right: 5px;" v-model="protocol"></el-checkbox>已阅读并同意
              <a href="https://source.yiboshi.com/licence/0417_shiyan/user.html" class="link">《用户协议》</a>和
              <a href="https://source.yiboshi.com/licence/0417_shiyan/pryvacy.html" class="link">《保护政策》</a>
          </div>
          <el-button :disabled="yzmloginbtn || !passwordYzm" size="mini" style="width: 100%" type="primary"
            @click="loginCell()">登录
          </el-button>
        </div>
        <!-- 滑块验证 -->
        <div v-if="verifyShow" class="verifyMain">
          <Verify ref="verify" :captchaType="'blockPuzzle'" :imgSize="{
                width: '230px',
                height: '120px',
              }" :mode="'fixed'" @success="success"></Verify>
          <div v-show="verifyOK" class="verifyOK">
            <i class="el-icon-success" style="color:#67C23A;margin-left:12px;margin-right:8px"></i>
            验证通过
          </div>
        </div>
        <div class="login_switch">
          <el-button v-if="accountCellSwitch === 2" icon="el-icon-user-solid" size="mini" type="text"
            @click="accountCellSwitch = 1;verifyShow=false">账号登录
          </el-button>
          <el-button v-if="accountCellSwitch === 1" icon="el-icon-s-comment" size="mini" type="text"
            @click="accountCellSwitch = 2;verifyShow=false">短信验证码登录
          </el-button>
        </div>
        <div class="account_operation">
          <el-button size="mini" type="text" @click="routingJump('/register')">账号注册</el-button>
          <el-button size="mini" type="text" @click="routingJump('/findByShortMsg')">忘记密码？</el-button>
        </div>
      
      </div>
      <div class="symt_login_bottom"></div>
    </div>
    
    <!--修改密码-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
      :visible.sync="passEditFormVisible" title="修改密码">
      <div class="new_jpkc_list" style="min-height: 200px;">
        <div class="new_userInfo_box" style="width: 90%;">
          <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="100px">
            <el-form-item label="旧 密 码" prop="oldPwd">
              <el-input v-model="pwdForm.oldPwd" class="baseInput" type="password"></el-input>
            </el-form-item>
            <el-form-item label="新 密 码" prop="newPwd">
              <el-input v-model="pwdForm.newPwd" class="baseInput" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="reNewPwd">
              <el-input v-model="pwdForm.reNewPwd" class="baseInput" type="password"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;width:91%;">
              <el-button style="width:30%;" type="primary" @click.native="editUserPwd">保　　存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
    
    <!--学员须知-->
    <el-dialog :visible="notice" title="学员登录必读" width="550px" @close="closeNotice">
      <div class="student_box" style="position: relative;margin-top: -20px;padding-top: 8px;padding-bottom: 8px">
        <ul>
          <li>登录用户名默认为您的<span>身份证号</span></li>
          <li>登录密码默认为<span>000000</span>，登录成功后<span>请立即修改密码</span>。</li>
          <li>密码修改成功，请牢记您的新密码，点击确认后跳转到首页重新登录。</li>
          <li>若登录后显示<span>用户名错误或不存在</span>，请<span>重新注册</span>。</li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { checkPwdRight, updatePassword } from '../api/api'
import util from '../common/js/util'
import md5 from 'crypto-js/md5'
import { mapActions, mapGetters } from 'vuex'
import learnCardBind from '../components/LearnCardBind'
import '../assets/wxLogin'
import Verify from './verifition/Verify'
import { aesEncryptWord } from './verifition/utils/ase'
import { getsms } from '../api/apiLoginVerify'
import smCrypto from 'sm-crypto'
import { PasswordReg, phoneReg } from '../utils/commonReg'

export default {
  components: {
    learnCardBind,
    Verify
  },
  data() {
    var validateRePwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (md5(value).toString() !== md5(this.pwdForm.newPwd).toString()) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    
    var validatePwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入旧密码'))
      } else {
        checkPwdRight({oldPwd: md5(value).toString(), userId: this.userInfo.id}).then((response) => {
          if (response.status == 200) {
            if (response.data.status == 200) {
              callback()
            } else {
              callback(new Error(response.data.msg))
            }
          }
        }).catch(() => {
        })
      }
    }
    
    return {
      usernameS: '',
      passwordS: '',
      vcode: '',
      vcodeuuid: '',
      captchaUrl: '',
      manageLoginType: 1,
      adminUserName: '',
      adminPassword: '',
      showLearnCardBind: false,
      passEditFormVisible: false,
      notice: false,
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        reNewPwd: ''
      },
      pwdRules: {
        oldPwd: [
          {required: true, validator: validatePwd, trigger: 'blur'}
        ],
        newPwd: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 22, message: '长度在 6 到 22 个字符', trigger: 'blur'}
        ],
        reNewPwd: [
          {required: true, validator: validateRePwd, trigger: 'blur'}
        ]
      },
      accountCellSwitch: 1, // 1 账号登录，2 手机号登录
      captchaVerificationAccount: {
        captchaVerification: ''
      },
      captchaVerification: {
        captchaVerification: ''
      },
      yzmCodeFlag: '', //login,cell,调用验证码按钮标识
      yzmeffect: false, //是否获取验证码并有效
      yzmloginbtn: true, //验证码登录按钮
      verifiModalVisible: false,
      verifyOK: false,
      verifyShow: false,
      usernameCell: '',
      passwordYzm: '',
      protocol:false
    }
  },
  mounted() {
    this.refreshCaptcha()
    var obj = new WxLogin({
      id: 'login_container',
      appid: process.env.WECHAT_APPID,
      scope: 'snsapi_login',
      redirect_uri: process.env.WEB30_URL,
      state: Math.random() * 100000,
      style: '',
      href: process.env.WEB30_URL + '/static/wx.css'
    })
  },
  computed: {
    // 使用对象展开运算符将 getters 混入 computed 对象中
    ...mapGetters([
      'userInfo'
      // ...
    ])
  },
  methods: {
    ...mapActions([
      'userLogin',
      'userLogout',
      'userLoginAccount',
      'userLoginCell'
    ]),
    /**
     * @description: 路由跳转
     */
    routingJump(url) {
      window.location.href = `${ window.location.origin }${ url }`
    },
    refreshCaptcha() {
      this.vcodeuuid = util.guid()
      this.captchaUrl = process.env.API_URL + 'api/public/captcha/captcha.jpg?key=' + this.vcodeuuid
    },
    showNotice() {
      this.notice = true
    },
    closeNotice() {
      this.notice = false
    },
    /**
     * @description: show 滑块
     */
    getyzm() {
      if (!phoneReg.test(this.usernameCell)) {
        this.$message.warning('请输入正确的手机号')
      } else {
        if (!this.protocol) {
          this.$message.warning('请阅读并同意《用户协议》和《保护政策》')
          return
        }
        this.yzmCodeFlag = 'cell'
        //  this.$refs.verify.refresh()
        this.verifyShow = true
        
      }
    },
    /**
     * @description: 登录按钮状态
     */
    subBtnDisabled() {
      return this.usernameS.length < 1 || this.passwordS.length < 1
    },
    /**
     * @description: 验证码按钮状态
     */
    yzmbtn() {
      if (this.usernameCell.length < 1) {
        return true
      } else return this.yzmeffect
    },
    /**
     * @description: 发送验证码按钮文字
     */
    sendSmsButtonText() {
      if (this.smsTime > 0) {
        return this.smsTime + 's'
      } else {
        this.yzmeffect = false
        return '获取验证码'
      }
    },
    /**
     * @description: 滑块成功
     */
    success(params) {
      this.verifyShow = false
      if (this.yzmCodeFlag === 'cell') { // 短信登录
        this.captchaVerification = params
        this.yzmloginbtn = false
        this.sendSmsMethod()
      } else {
        this.captchaVerificationAccount = params
        this.loginS('login')
      }
    },
    smsTimer() {
      if (this.smsTime > 0) {
        this.yzmeffect = true // 验证码在60s有效期
        this.smsTime--
        this.sendSmsButtonDisabled = true
        setTimeout(this.smsTimer, 1000)
      } else {
        this.yzmeffect = false
      }
    },
    /**
     * @description: 发送验证码
     */
    sendSmsMethod() {
      let param = {
        mobile: aesEncryptWord(this.usernameCell),
        captchaVerification: this.captchaVerification.captchaVerification,
        flag: 1
      }
      getsms(param).then(res => {
        this.$message.success('已发送手机验证码')
        this.smsTime = 60
        this.smsTimer()
        this.mobileCodeKey = res.key
        
      })
    },
    /**
     * @description: 账号密码登录
     */
    loginS(param) {
      if (!this.protocol) {
        this.$message.warning('请阅读并同意《用户协议》和《保护政策》')
        return
      }
      if (!this.usernameS || !this.passwordS) {
        this.$message.warning('用户名或密码不允许为空！')
        return
      }
      if (param) this.yzmCodeFlag = param
      if (!this.captchaVerificationAccount.captchaVerification) {
        this.verifyShow = true
      } else {
        let fromData = new FormData()
        fromData.append('username', this.usernameS)
        fromData.append('password', md5(this.passwordS).toString())
        fromData.append('password2', smCrypto.sm3(this.passwordS))
        fromData.append('captchaVerification', this.captchaVerificationAccount.captchaVerification)
        this.userLoginAccount(fromData).then(res => {
          this.captchaVerificationAccount.captchaVerification = ''
          if (!res.success) return
          localStorage.removeItem(`${ res.userInfo.uuid }_pw_weak`)
          const passwordTest = PasswordReg.test(this.passwordS)
          // console.log(this.passwordS)
          // console.log(passwordTest)
          if (!passwordTest) { //密码强度不符合规范
            localStorage.setItem(`${ res.userInfo.uuid }_pw_weak`, 'true') //记录弱密码标记
            // console.log('弱密码弹窗')
            if (!this.changePasswordShow) this.changePasswordShow = true //进入修改密码步骤
          } else {
            //未校验手机号
            if (!this.userInfo.mobile || this.userInfo.isMobileVerify !== 1) {
              this.verifiModalVisible = true
            }
          }
          this.$message.success('登录成功')
          this.routingJump('/usercenter/index')
        }).catch(() => {
          this.captchaVerificationAccount.captchaVerification = ''
        })
      }
    },
    loginCell() {
      //手机号登录
      if (!this.usernameCell || !this.passwordYzm) {
        this.$message.warning('手机号或验证码不允许为空！')
        return
      }
      //1:校验验证码是否正确 2：短信登录
      let fromData = new FormData()
      fromData.append('mobile', aesEncryptWord(this.usernameCell))
      fromData.append('captcha', aesEncryptWord(this.passwordYzm))
      // fromData.append(
      //   "captchaVerification",
      //   this.captchaVerification.captchaVerification
      // );
      this.userLoginCell(fromData).then(res => {
        if (res.success == true) {
          if (
            this.userInfo.mobile == '' ||
            this.userInfo.mobile == null ||
            this.userInfo.mobile == undefined ||
            this.userInfo.isMobileVerify != 1
          ) {
            //未校验手机号
            this.verifiModalVisible = true
          }
          this.$message.success('登录成功')
          this.routingJump('/usercenter/index')
        } else {
          this.$message.warning(res.msg)
        }
        this.captchaVerification.captchaVerification = ''
      }).catch(res => {
        // this.$message.warning(res.msg);
        this.captchaVerification.captchaVerification = ''
      })
    },
    editUserPwd() {
      this.$refs.pwdForm.validate((valid) => {
        let param = {newPwd: md5(this.pwdForm.newPwd).toString(), userId: this.userInfo.id}
        if (valid) {
          updatePassword(param).then((response) => {
            var data = response
            if (data.status == 200) {
              this.$alert('修改密码成功！请点击“确定”并重新登录！', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.passEditFormVisible = false
                  this.userLogout()
                  this.$router.push('/')
                }
              })
              this.pwdForm.oldPwd = ''
              this.pwdForm.newPwd = ''
              this.pwdForm.reNewPwd = ''
            } else {
              this.$message({
                type: 'warning',
                message: '操作失败！'
              })
            }
          }).catch(function (error) {
          })
        } else {
          return false
        }
      })
    }
    /*teachManageLogin(){
     if (this.manageLoginType == 1) {
     teachManageLogin({username: this.adminUserName, password: md5(this.adminPassword)}).then((response) => {
     let {data} = response
     if (data.status == 200) {
     window.location.href=process.env.TEACH_ADMIN_URL + '?token=' + data.data.token+'&logoutUrl='+window.location.href;
     } else {
     this.$notify.info({
     title: '消息',
     message: response.data.msg
     });
     }
     })
     } else {
     jsonp(process.env.EXAM_API_URL + '/auth/checklogin?username=' + this.adminUserName + "&password=" + md5(this.adminPassword)
     , (err, data) => {
     if (err) {
     this.$notify.error({
     title: '错误',
     message: '未知错误！'
     });
     return null;
     } else {
     if(data.data==true){
     getServerNowTime().then((response) => {
     var ts = this.$moment(response.data).valueOf();
     let fp = md5(this.adminUserName + ts + "INDEX").toString().toUpperCase();
     let reUrl = process.env.EXAM_MANAGE_API_URL + "/login/oauth2"
     + "?" + "turl=" + process.env.EXAM_MANAGE_API_URL + "/main" //目标地址
     + "&" + "eurl=" + window.location.href // 退出登录回调地址
     + "&" + "ts=" + ts
     + "&" + "from=" + "INDEX"
     + "&" + "userName=" + this.adminUserName
     + "&" + "fp=" + fp
     + "&" + "ec=" + 1;
     window.location.href=reUrl;
     })
     }else{
     this.$notify.info({
     title: '消息',
     message: data.message
     });
     }
     }
     });
     }
     }*/
  }
}
</script>

<style lang="less" scoped>
.Login {
  /deep/ .symt_login_box {
    position: relative;
    
    .verifyMain {
      position: absolute;
      top: 0;
      right: 0;
      width: 260px;
      height: 200px;
      padding: 10px;
      background: #FFFFFF;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
      z-index: 999;
    }
    
    .account_login, .sms_login {
      padding: 0 20px;
      
      .el-input {
        margin-bottom: 8px;
        
        ::placeholder {
          font-size: 12px;
          font-weight: 400;
          line-height: 30px;
        }
        
        .el-input__inner {
          height: 30px;
          line-height: 30px;
        }
        
        .el-input__prefix {
          top: -1px;
          
          .el-input__icon {
            font-size: 16px;
          }
        }
      }
      
      .code {
        display: flex;
        
        .el-button {
          height: 28px;
          margin-left: 4px;
          padding: 4px 8px;
          font-weight: 400;
        }
      }
    }
    
    .login_switch {
      padding: 0 20px;
      text-align: center;
      
      .el-button--text {
        padding: 4px 0;
        font-weight: 400;
        
        i {
          font-size: 14px;
        }
      }
    }
    
    .account_operation {
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      
      .el-button--text {
        font-weight: 400;
        padding: 0 20px;
      }
    }
    .link{
      color:#2080B1;
    }
    .nlb_useragreenment{

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue